import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import { FacebookProvider } from "react-facebook"

const RootProvider = ({ children }) => (
  <StaticQuery
    query={graphql`
      query FacebookAppId {
        site {
          siteMetadata {
            fbAppId
          }
        }
      }
    `}
    render={data => (
      <FacebookProvider wait appId={data.site.siteMetadata.fbAppId}>
        {children}
      </FacebookProvider>
    )}
  />
)

RootProvider.propTypes = {
  children: PropTypes.node,
}

export default RootProvider
